import { render, staticRenderFns } from "./nearby-shop.vue?vue&type=template&id=1d29d119&scoped=true&"
import script from "./nearby-shop.vue?vue&type=script&lang=js&"
export * from "./nearby-shop.vue?vue&type=script&lang=js&"
import style0 from "./nearby-shop.vue?vue&type=style&index=0&id=1d29d119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d29d119",
  null
  
)

export default component.exports